import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import { Button, Modal, Spinner } from "react-bootstrap";
import uploadIcon from "../draganddrop/img/upload.svg";
import "./imageScanStyle.scss";

const ImageScan = ({ onUpload }) => {
  const webcamRef = useRef(null);
  const [images, setImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [webcamKey, setWebcamKey] = useState(0);
  const [loading, setLoading] = useState(true);

  const openCamera = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowModal(true);
    setWebcamKey(prevKey => prevKey + 1);
    setLoading(true);
  };


  const closeCamera = () => setShowModal(false);

  const capture = () => {
    if (!webcamRef.current) return;
    const imageSrc = webcamRef.current.getScreenshot();
    if (!imageSrc) return;

    setImages((prevImages) => {
      if (prevImages.length < 2) {
        return [...prevImages, imageSrc]; // Allow only 2 images
      }
      return prevImages;
    });

    if (images.length + 1 === 2) {
      closeCamera(); // Close modal after 2 captures
    }
  };

  const uploadFile = () => {
    onUpload(images, 'SCAN')
  }

  return (
    <div className="file-upload-container">
      <div className="file-drop-zone d-flex flex-column align-items-center" onClick={openCamera}>
        <img src={uploadIcon} alt="Upload Icon" className="upload-icon" />
        <label htmlFor="fileInput" className="uploadLink mt-2">
          Click here to scan the image
        </label>
      </div>

      {images.length > 0 && (
        <div className="file-list">
          <h6>Scanned Files:</h6>
          <div className="mt-3 d-flex justify-content-start gap-3">
            {images.map((img, index) => (
              <img key={index} src={img} alt={`Captured ${index + 1}`} className="img-fluid rounded preview-image" />
            ))}
          </div>
        </div>
      )}

      {images.length === 2 && (
        <Button variant="primary" className="upload-btn" onClick={uploadFile}>Upload</Button>
      )}

      <Modal show={showModal} onHide={closeCamera} centered>
        <Modal.Header closeButton>
          <Modal.Title>Capture Image</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div className="d-flex justify-content-center align-items-center text-center w-100">
            {loading && (
              <div className="d-flex justify-content-center w-100">
                <Spinner animation="border" variant="primary" />
              </div>
            )}
          </div>
          <div className="webcam-container">
            <Webcam
              key={webcamKey}
              ref={webcamRef}
              screenshotFormat="image/png"
              onUserMedia={() => setLoading(false)}
            />
          </div>


        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeCamera}>
            Close
          </Button>
          <Button variant="primary" onClick={capture}>
            Capture
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ImageScan;
